export default "__VITE_ASSET__b8047098__"